import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DatePipe } from '@angular/common';
import { ErrorHandler } from '@angular/core';
import { ErrorHandlerService } from '../../../services/errorHandler.service';
import { MatDialogModule } from '@angular/material/dialog';
import { SharedModule } from '../../../shared/shared.module';

// Import all BackOffice24 components
import { BackOffice24Component } from './back-office24.component';
import { BackOffice24ModulesComponent } from './back-office24-modules/back-office24-modules.component';
import { BackOffice24GatesComponent } from './back-office24-gates/back-office24-gates.component';
import { BackOffice24ParkingCheckInOutComponent } from './back-office24-parkingcheckinout/back-office24-parkingcheckinout.component';
import { BackOffice24OrderListComponent } from './back-office24-orders/back-office24-order-list/back-office24-order-list.component';
import { BackOffice24OrderDetailsComponent } from './back-office24-orders/back-office24-order-details/back-office24-order-details.component';
import { BackOffice24OrderLogDetailsComponent } from './back-office24-orders/back-office24-order-log/back-office24-order-log-details/back-office24-order-log-details.component';
import { BackOffice24OrderLogComponent } from './back-office24-orders/back-office24-order-log/back-office24-order-log.component';
import { BackOffice24OrderParkingEditComponent } from './back-office24-orders/back-office24-order-parking-edit/back-office24-order-parking-edit.component';
import { BackOffice24OrderParkingEditTimeComponent } from './back-office24-orders/back-office24-order-parking-edit-time/back-office24-order-parking-edit-time.component';
import { BackOffice24OrderTransactionComponent } from './back-office24-orders/back-office24-order-transaction/back-office24-order-transaction.component';
import { BackOffice24OrderTransactionCreateComponent } from './back-office24-orders/back-office24-order-transaction-create/back-office24-order-transaction-create.component';
import { BackOffice24OrderTransactionDetailsComponent } from './back-office24-orders/back-office24-order-transaction-details/back-office24-order-transaction-details.component';
import { BackOffice24TravelAgencyBottomsheetComponent } from './back-office24-boka/back-office24-travel-agency/back-office24-travel-agency-bottomsheet/back-office24-travel-agency-bottomsheet.component';
import { BackOffice24TravelAgencyFormComponent } from './back-office24-boka/back-office24-travel-agency/back-office24-travel-agency-form/back-office24-travel-agency-form.component';
import { BackOffice24OrderShuttlePlanningComponent } from './back-office24-shuttle/back-office24-order-shuttle-planning/back-office24-order-shuttle-planning.component';
import { BackOffice24OrderShuttlePlanningDetailsComponent } from './back-office24-shuttle/back-office24-order-shuttle-planning-details/back-office24-order-shuttle-planning-details.component';
import { BackOffice24OrderShuttlebusBookingsComponent } from './back-office24-shuttlebus/back-office24-ordershuttlebus-bookings/back-office24-ordershuttlebus-bookings.component';
import { BackOffice24OrderShuttlebusCheckinComponent } from './back-office24-shuttlebus/back-office24-ordershuttlebus-checkin/back-office24-ordershuttlebus-checkin.component';
import { BackOffice24OrderShuttlebusCreateComponent } from './back-office24-shuttlebus/back-office24-ordershuttlebus-create/back-office24-ordershuttlebus-create.component';
import { BackOffice24OrderShuttlebusDetailsComponent } from './back-office24-shuttlebus/back-office24-ordershuttlebus-details/back-office24-ordershuttlebus-details.component';
import { BackOffice24OrderShuttlebusEditComponent } from './back-office24-shuttlebus/back-office24-ordershuttlebus-edit/back-office24-ordershuttlebus-edit.component';
import { BackOffice24OrderShuttlebusArrivalComponent } from './back-office24-shuttlebus/back-office24-ordershuttlebus-flight/back-office24-ordershuttlebus-arrival/back-office24-ordershuttlebus-arrival.component';
import { BackOffice24OrderShuttlebusDepartureComponent } from './back-office24-shuttlebus/back-office24-ordershuttlebus-flight/back-office24-ordershuttlebus-departure/back-office24-ordershuttlebus-departure.component';
// import { BackOffice24OrderShuttlebusPlanArrivalComponent } from './back-office24-shuttlebus/back-office24-ordershuttlebus-plan/back-office24-ordershuttlebus-plan-arrival/back-office24-ordershuttlebus-plan-arrival.component';
// import { BackOffice24OrderShuttlebusPlanDepartureComponent } from './back-office24-shuttlebus/back-office24-ordershuttlebus-plan/back-office24-ordershuttlebus-plan-dep/back-office24-ordershuttlebus-plan-dep.component';
import { BackOffice24OrderAddAdditionalServicesComponent } from './back-office24-orders/back-office24-order-add-additional-services/back-office24-order-add-additional-services.component';
import { BackOffice24OrdersEditAdditionalServiceComponent } from './back-office24-orders/back-office24-orders-edit-additional-service/back-office24-orders-edit-additional-service.component';
import { BackOffice24OrdersEditVehicleKeySafeComponent } from './back-office24-orders/back-office24-orders-edit-vehicle-key-safe/back-office24-orders-edit-vehicle-key-safe.component';
import { ParkingPricingListComponent } from './back-office24-pricing/parking-pricing-list/parking-pricing-list.component';
import { ParkingPricingFormComponent } from './back-office24-pricing/parking-pricing-form/parking-pricing-form.component';
import { ParkingPricingBulkUpdateFormComponent } from './back-office24-pricing/parking-pricing-bulk-update-form/parking-pricing-bulk-update-form.component';
import { BackOffice24PricingComponent } from './back-office24-pricing/back-office24-pricing.component';
import { DiscountFormComponent } from './back-office24-pricing/discount-form/discount-form.component';
import { AdditionalServicesListComponent } from './back-office24-pricing/additional-services-list/additional-services-list.component';
import { AdditionalServicesFormComponent } from './back-office24-pricing/additional-services-form/additional-services-form.component';
import { ComingSoonComponent } from './coming-soon/coming-soon.component'
import { BackOffice24Routes } from './back-office24.routes';
import { BackOffice24StatesService } from './state/back-office24-states.service';
import { KeyTasksListComponent } from './key-tasks-list/key-tasks-list.component';
import { OrgVehiclesComponent } from './org-vehicles/org-vehicles.component';
import { OrgVehicleEditComponent } from './org-vehicles/org-vehicle-edit/org-vehicle-edit.component';
import { BackOffice24StartComponent } from './back-office24-start/back-office24-start.component';
import { BackOffice24OrderListPaginationComponent } from './back-office24-orders/back-office24-order-list-pagination/back-office24-order-list-pagination.component';
import { OpenGateFormComponent } from './back-office24-gates/open-gate-form/open-gate-form.component';
import { BackOffice24OrderTransactionManagerComponent } from './back-office24-orders/back-office24-order-transaction-manager/back-office24-order-transaction-manager.component';
import { OrderAdditionalServiceListComponent } from './back-office24-orders/order-additional-service-list/order-additional-service-list.component';
import { DebtListComponent } from './back-office24-orders/debt-list/debt-list.component';

// LPR
import { LprImagesComponent } from './lpr-images/lpr-images.component';
import { LprLogsComponent } from './lpr-logs/lpr-logs.component';
import { LprLogDetailsPageComponent } from './lpr-logs/lpr-log-details-page/lpr-log-details-page.component';

import { ArrivalDepartureListComponent } from './arrivaldeparture/arrivaldeparture-list/arrivaldeparture-list.component';
import { ArrivalListComponent } from './arrivaldeparture/arrival-list/arrival-list.component';
import { DepartureListComponent } from './arrivaldeparture/departure-list/departure-list.component';
import { ArrivalDepartureDetailsComponent } from './arrivaldeparture/arrivaldeparture-details/arrivaldeparture-details.component';
import { DepartureNewComponent } from './arrivaldeparture/departure-new/departure-new.component';
import { ArrivalNewComponent } from './arrivaldeparture/arrival-new/arrival-new.component';

import { ParkingComponent } from './parkings/parking.component';
import { ParkingEditComponent } from './parkings/parking-edit/parking-edit.component';
import { ParkingEditConfirmComponent } from './parkings/parking-edit/parking-edit-confirm/parking-edit-confirm.component';
import { OrgParkingListComponent } from './parkings/org-parking-list/org-parking-list.component';
import { OrgParkingEditComponent } from './parkings/org-parking-edit/org-parking-edit.component';

import { ProblemFlightsListComponent } from './problem-flights-list/problem-flights-list.component';
import { BackOffice24UsersComponent } from './back-office24-users/back-office24-users.component';
import { BackOffice24UsersEditComponent } from './back-office24-users/back-office24-users-edit/back-office24-users-edit.component';
import { BackOffice24UsersAddComponent } from './back-office24-users/back-office24-users-add/back-office24-users-add.component';

import { ReportsComponent } from './reports/reports.component';
import { ShuttleCompareComponent } from './reports/shuttle-compare/shuttle-compare.component';
import { CamerasComponent } from './cameras/cameras.component';
import { CustomersComponent } from './customers/customers.component';
import { OperatorsComponent } from './operators/operators.component';
import { RouteSchedulesComponent } from './route-schedules/route-schedules.component';
import { GpsTrackingComponent } from './gps-tracking/gps-tracking.component';
import { MyBusComponent } from './my-bus/my-bus.component';
import { RouteScheduleSlotEditComponent } from './route-schedules/route-schedule-slot-edit/route-schedule-slot-edit.component';
import { RouteScheduleDuplicateComponent } from './route-schedules/route-schedule-duplicate/route-schedule-duplicate.component';
import { RouteScheduleDiffConfirmComponent } from './route-schedules/route-schedule-diff-confirm/route-schedule-diff-confirm.component';
import { RouteScheduleResolveComponent } from './route-schedules/route-schedule-resolve/route-schedule-resolve.component';
import { RouteScheduleOverrideCreateComponent } from './route-schedules/route-schedule-override-create/route-schedule-override-create.component';
import { ParkiflyUsersComponent } from './parkifly-users/parkifly-users.component';
import { ParkingFinesComponent } from './parking-fines/parking-fines.component';
import { FinanceComponent } from './finance/finance.component';
import { SettingsComponent } from './settings/settings.component';
import { InternalBookingFormComponent } from '../../../parkifly-bookings/organizations/features/booking/components/form/internal-booking/internal-booking-form/internal-booking-form.component';
import { InternalBookingSummaryComponent } from '../../../parkifly-bookings/organizations/features/booking/components/form/internal-booking/internal-booking-summary/internal-booking-summary.component';
import { TransactionListComponent } from './finance/transaction-list/transaction-list.component';
import { BackOffice24AddOrganizationComponent } from './back-office24-users/back-office24-add-organization/back-office24-add-organization.component';
import { BackOffice24OrgMembersComponent } from './back-office24-users/back-office24-org-members/back-office24-org-members.component';
import { TransactionListPaginatedComponent } from './finance/transaction-list-paginated/transaction-list-paginated.component';
import { AdditionalServiceTasksComponent } from './additional-service-tasks/additional-service-tasks.component';
import { MobileNotificationFormComponent } from './back-office24-orders/mobile-notification-form/mobile-notification-form.component';
import { MaintenanceGatesComponent } from './maintenance-gates/maintenance-gates.component';
import { AdditionalServicePlanningComponent } from './additional-service-planning/additional-service-planning.component';
import { UnplannedTasksModalComponent } from './additional-service-planning/unplanned-tasks-modal/unplanned-tasks-modal.component';
import { TimeSlotsModalComponent } from './additional-service-planning/time-slots-modal/time-slots-modal.component';
import { ScheduleTemplatesModalComponent } from './additional-service-planning/schedule-templates-modal/schedule-templates-modal.component';
import { ProblemDevicesModalComponent } from './back-office24-start/problem-devices-modal/problem-devices-modal.component';
import { ProblemOrdersModalComponent } from './back-office24-start/problem-orders-modal/problem-orders-modal.component';
import { DisplayTestsComponent } from './parking-display/display-tests/display-tests.component';
import { QualityInternalBookingFormComponent } from '../../../parkifly-bookings/organizations/features/booking/components/form/internal-booking/quality-internal-booking-form/quality-internal-booking-form.component';
import { InvoiceListComponent } from './operators/invoice-list/invoice-list.component';

@NgModule({
  declarations: [
    BackOffice24Component,
    BackOffice24ModulesComponent,
    BackOffice24StartComponent,
    BackOffice24GatesComponent,
    MaintenanceGatesComponent,
    BackOffice24ParkingCheckInOutComponent,
    AdditionalServiceTasksComponent,
    AdditionalServicePlanningComponent,
    UnplannedTasksModalComponent,
    TimeSlotsModalComponent,
    ScheduleTemplatesModalComponent,
    ProblemDevicesModalComponent,
    ProblemOrdersModalComponent,

    // Orders
    BackOffice24OrderListComponent,
    BackOffice24OrderDetailsComponent,
    BackOffice24OrderLogDetailsComponent,
    BackOffice24OrderLogComponent,
    BackOffice24OrderParkingEditComponent,
    BackOffice24OrderParkingEditTimeComponent,
    BackOffice24OrderTransactionComponent,
    BackOffice24OrderTransactionCreateComponent,
    BackOffice24OrderTransactionDetailsComponent,
    BackOffice24OrderShuttlebusBookingsComponent,
    BackOffice24OrderShuttlebusCheckinComponent,
    BackOffice24OrderShuttlebusCreateComponent,
    BackOffice24OrderShuttlebusDetailsComponent,
    BackOffice24OrderShuttlebusEditComponent,
    BackOffice24OrderShuttlebusArrivalComponent,
    BackOffice24OrderShuttlebusDepartureComponent,
    // BackOffice24OrderShuttlebusPlanArrivalComponent,
    // BackOffice24OrderShuttlebusPlanDepartureComponent,
    BackOffice24OrderShuttlePlanningComponent,
    BackOffice24OrderShuttlePlanningDetailsComponent,
    BackOffice24OrderAddAdditionalServicesComponent,
    BackOffice24OrdersEditAdditionalServiceComponent,
    BackOffice24OrdersEditVehicleKeySafeComponent,
    OrderAdditionalServiceListComponent,
    DebtListComponent,
    BackOffice24OrderListPaginationComponent,
    BackOffice24OrderTransactionManagerComponent,
    MobileNotificationFormComponent,

    LprImagesComponent,
    LprLogsComponent,
    LprLogDetailsPageComponent,

    // Travel Agency
    BackOffice24TravelAgencyBottomsheetComponent,
    BackOffice24TravelAgencyFormComponent,

    // Pricing
    ParkingPricingListComponent,
    ParkingPricingFormComponent,
    ParkingPricingBulkUpdateFormComponent,
    BackOffice24PricingComponent,
    DiscountFormComponent,
    AdditionalServicesListComponent,
    AdditionalServicesFormComponent,

    ComingSoonComponent,
    KeyTasksListComponent,
    OrgVehiclesComponent,
    OrgVehicleEditComponent,
    OpenGateFormComponent,
    BackOffice24UsersComponent,
    BackOffice24UsersAddComponent,
    BackOffice24UsersEditComponent,
    BackOffice24AddOrganizationComponent,
    BackOffice24OrgMembersComponent,
    InternalBookingFormComponent,
    InternalBookingSummaryComponent,
    QualityInternalBookingFormComponent,

    // ArrivalDeparture
    ArrivalDepartureListComponent,
    ArrivalListComponent,
    DepartureListComponent,
    ArrivalDepartureDetailsComponent,
    DepartureNewComponent,
    ArrivalNewComponent,

    // Parking
    ParkingComponent,
    ParkingEditComponent,
    ParkingEditConfirmComponent,
    OrgParkingListComponent,
    OrgParkingEditComponent,

    // Problem Flights
    ProblemFlightsListComponent,

    ReportsComponent,
    ShuttleCompareComponent,

    CamerasComponent,
    OperatorsComponent,
    InvoiceListComponent,
    ParkiflyUsersComponent,
    CustomersComponent,
    ParkingFinesComponent,
    SettingsComponent,
    RouteSchedulesComponent,
    GpsTrackingComponent,
    MyBusComponent,
    RouteScheduleSlotEditComponent,
    RouteScheduleDuplicateComponent,
    RouteScheduleDiffConfirmComponent,
    RouteScheduleResolveComponent,
    RouteScheduleOverrideCreateComponent,

    //Finance
    TransactionListComponent,
    TransactionListPaginatedComponent,
    FinanceComponent,

    DisplayTestsComponent
  ],
  imports: [
    SharedModule,
    MatDialogModule,
    RouterModule.forChild(BackOffice24Routes),
    RouterModule,
  ],
  providers: [
    BackOffice24StatesService,
    DatePipe,
    { provide: ErrorHandler, useClass: ErrorHandlerService },
  ]
})
export class BackOffice24Module { }
